const en = {
    general: {
        app_name: "Tracky",
        dashboard: "Dashboard",
        entries: "Entries",
        media: "Media",
        other: "Other",
        settings: "Settings",
        location: "Locations",
        general: "General",
        activities: "Activities",
        dark_mode: "Dark mode",
        save: "Save",
        edit: "Edit",
        cancel: "Cancel",
        delete: "Delete",
        new: "New",
        time: "Time",
        close: "Close",
        search: "Search",
        text: "Text",
        no_date_defined: "No date defined",
        day_of_week: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday"
        },
        time_of_day: {
            morning: "Morning",
            afternoon: "Afternoon",
            evening: "Evening",
            night: "Night",
            workout: "Workout"
        },
        month: {
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December"
        }
    },
    today: {
        notification: {
            entry_saved: "The entry has been saved."
        },
        header: "Daily",
        add: "Add",
        title: "Title",
        text: "Text",
        save: "Save",
        mood: "Mood",
        entry: "Entry",
        edit: "Edit",
        select_date: "Select date",
        total_locations_at_this_point: "Total locations at this point"
    },
    mood_card: {
        notification: {
            mood_saved: "The mood has been saved."
        },
        mood: "Mood"
    },
    location_card: {
        header: "Location",
        open_location_points: "Open location points"
    },
    sessioncard: {
        delete: "Delete",
        device_name: "Device name",
        device_os: "Device OS",
        started: "Started"
    },
    settings: {
        header: "Settings",
        language: "Language",
        change_password: "Change password",
        current_password: "Current password",
        new_password: "New password",
        repeat_new_password: "Repeat new password",
        change: "change",
        profile: "Profile",
        sign_out: "Sign out",
        devices: "Devices",
        devices_description: "You find here all devices where you are signed in.",
        setup_two_factor: "Setup 2FA",
        type_here_the_six_digit_code: "Type here the six digit code:",
        code: "Code",
        disable_two_factor: "Disable 2FA",
        setup: "Setup",
        export_my_data: "Export my data"
    },
    register: {
        email: "Email",
        password: "Password",
        repeat_password: "Repeat password",
        register: "Register",
        or_want_to_login: "or want to login?"
    },
    activate: {
        notification: {
            user_activated: "The user is now activated."
        }
    },
    login: {
        login: "Login",
        email: "Email",
        password: "Password",
        register_now: "Register now",
        forgot_password: "Forgot password?",
        two_factor_authentication: "Two factor authentication",
        verify: "Verify"
    },
    forgot_password: {
        header: "Forgot password?",
        header_description: "Enter below your email of your account. We will send then you a link, where you can reset your password.",
        email: "Email",
        request_password: "Request password",
        or_want_to_login: "Sign in?"
    },
    reset_password: {
        notification: {
            new_password_has_been_set: "The new password has been set.",
            passwords_do_not_match: "The passwords do not match with each other."
        },
        header: "Reset password",
        header_description: "You can set here now a new password for your account. This password will then be valid.",
        new_password: "New password",
        repeat_new_password: "Repeat new password",
        reset: "Reset"
    },

    timeline: {
        header: "Timeline",
        no_data_recorded_for_this_date_yet: "No data recorded for this day yet.",
        install_the_companion: "Install the companion app to upload data automatically.",
        or: "Or",
        try_import_snapplace: "Try to import from SnapPlace",
        you_can_import_this_day_tomorrow: "You can import this day tomorrow.",
        on_the_way: "On the way",
        no_data_recorded_for_this_month_yet: "No data recorded for this month yet.",
        no_data_recorded_for_this_year_yet: "No data recorded for this year yet.",
        most_visited_cities: "Most Visited Cities",
        most_visited_countries: "Most Visited Countries",
        unknown_city: "Unknown City",
        unknown_country: "Unknown Country",
        visits_recorded: "visits recorded",
        yearly_view: "Yearly View",
        monthly_view: "Monthly View",
        daily_view: "Daily View",
        select_month: "Select Month",
        select_year: "Select Year",
        show_range: "Show",
        year: "Year",
        do_you_really_want_to_delete_this_day: "Do you really want to delete this day?",
        do_you_really_want_to_delete_this_point: "Do you really want to delete this point?",
        do_you_really_want_to_retrieve_missing_addresses: "Do you really want to retrieve missing addresses? This might take a while.",
        delete_this_day: "Delete this day",
        retrieve_missing_addresses: "Retrieve missing addresses",
        switch_to_group_view: "Switch to Group View",
        switch_to_point_view: "Switch to Point View",
        enter_edit_mode: "Enter Edit Mode",
        exit_edit_mode: "Exit Edit Mode",
        edit_location: "Edit Location",
        address: "Address",
        search_location: "Search Location",
        e_g: "e.g. {location}",
        from: "From",
        to: "To",
        any: "Any",
        clear_dates: "Clear Dates",
        apply_filters: "Apply Filters",
        no_locations_found: "No locations found for this query.",
        no_locations_hint: "Adjust your search filters or try a different keyword to find what you're looking for.",
        reset_search: "Reset Search",
        insights_for: "Insights for",
        memory_year_ago: "On this day, 1 year ago",
        memory_years_ago: "On this day, {years} years ago",
        random_memory: "A random memory from your timeline",
        you_were_here_on: "You were here on",
        you_were_here_from: "You were here from",
        you_visited_here_across: "You visited here across",
        different_periods: "different periods:",
        points: "points",
        total: "Total",
        recorded_points: "recorded points",
        results: "Results",
        switch_to_list_view: "Switch to List View",
        switch_to_aggregated_view: "Switch to Aggregated View",
        show_heatmap: "Show Heatmap",
        hide_heatmap: "Hide Heatmap",
        total_distance: "Total Distance",
        points_recorded: "Points Recorded",
        cities_visited: "Cities Visited",
        countries_visited: "Countries Visited",
        places_visited: "Places Visited",
        more_cities: "more",
        km: "km",
        search_fields: {
            city: "City",
            address: "Full Address",
            country: "Country"
        },
        notification: {
            day_deleted: "The day timeline has been deleted.",
            error_deleting_point: "There was an error while deleting a point.",
            error_fetching_locations: "There was an error while trying to fetch the locations to delete.",
            point_deleted: "Point deleted.",
            error_updating_location: "Error updating location.",
            location_updated: "Location updated.",
            enter_address_to_search: "Please enter an address to search.",
            error_fetching_search_results: "Error fetching search results.",
            no_missing_addresses_found: "No points with missing addresses were found.",
            retrieving_addresses: "Retrieving addresses...",
            addresses_retrieved: "Addresses retrieved."
        }
    },

    tracks: {
        notification: {
            track_has_been_imported: "The track has been imported.",
            file_not_supported: "This file is not supported.",
            track_has_been_saved: "The track has been saved.",
            track_has_been_deleted: "The track has been deleted."
        },
        types: {
            driving: "Driving",
            walking: "Walking",
            running: "Running",
            hiking: "Hiking",
            biking: "Biking",
            sailing: "Sailing",
            boating: "Boating",
            skiing: "Skiing",
            snowboarding: "Snowboarding",
            sledding: "Sledding"
        },
        header: "Tracks",
        import: "Import",
        name: "Name",
        elevation: "Elevation",
        meters_above_sea: "Meters above sea",
        bpm: "BPM",
        heartRate: "Heart rate",
        distance: "Distance",
        duration: "Duration",
        date: "Date",
        time: "Time",
        edit: "Edit",
        type: "Type",
        search: "Search for tracks...",
        heartRateAvg: "Average Heart Rate",
        uphill: "Altitude uphill",
        downhill: "Altitude downhill",
        min_distance: "Minimum Distance",
        max_distance: "Maximum Distance",
        speed: "Speed",
        power: "Power",
        cadence: "Cadence",
        averageSpeed: "Average Speed",
        maxElevation: "Max Elevation",
        minElevation: "Min Elevation",
        maxHeartRate: "Max Heart Rate"
    },

    fitness: {
        header: "Fitness",
        import: "Import",
        import_range: "Import Range...",
        import_date_range_title: "Import Date Range",
        importing_progress: "Importing {current} of {total} ({date})...",
        import_failed: "Import failed on {date}. Please ensure you are authenticated by syncing a single day first.",
        import_success: "Successfully imported data for {count} day(s).",
        steps: "Steps",
        resting_heart_rate: "Average heart rate",
        calories: "Calories",
        floors: "Floors",
        import_data: "Import from services",
        distance: "Distance",
        sleep_effective: "Effective sleep",
        sleep_total: "Total sleep",
        weight: "Weight",
        body_fat: "Body Fat",
        muscle_mass: "Muscle Mass",
        bone_mass: "Bone Mass",
        hydration: "Hydration",
        spo2: "SpO2",
        body_temperature: "Body Temperature",

        no_data_here: "There are no data for this date.",
        stats: "Overview",

        all_time: "All-time",
        all_time_steps: "All-time steps",
        all_time_distance: "All-time distance",
        all_time_average_steps: "All-time average daily steps",
        all_time_floors: "All-time floors",

        history_insights: "History Insights",
        dynamic_insights: "Dynamic Insights",
        time_range: "Time Range",
        group_by: "Group By",
        metric: "Metric",
        
        last_30_days: "Last 30 Days",
        last_3_months: "Last 3 Months",
        last_6_months: "Last 6 Months",
        last_year: "Last Year",
        
        by_day: "By Day",
        by_month: "By Month",
        by_year: "By Year",
        
        average_sleep: "Average Sleep",

        insight_most_active_day_title: "Most Active Day",
        insight_most_active_day_text: "You hit your peak on {date} with {steps} steps.",
        insight_distance_milestone_title: "Distance Milestone",
        insight_distance_milestone_text: "You've covered {distance} km in this period! That's roughly {marathons} marathons.",
        insight_best_sleep_title: "Best Night of Sleep",
        insight_best_sleep_text: "Your best rest was on {date}, clocking in at {sleep}.",
        insight_peak_climbing_title: "Peak Climbing Day",
        insight_peak_climbing_text: "You crushed {floors} floors on {date}.",
        insight_active_streak_title: "Longest Active Streak",
        insight_active_streak_text: "Your longest streak of 10k+ steps is {streak} days in a row!",
        insight_calorie_burner_title: "Ultimate Calorie Burner",
        insight_calorie_burner_text: "You burned a massive {calories} calories on {date}.",
        
        insight_total_steps_title: "Step Master",
        insight_total_steps_text: "You walked an incredible {steps} steps in this period.",
        insight_avg_steps_title: "Daily Average",
        insight_avg_steps_text: "You average {steps} steps a day.",
        insight_rest_day_title: "Recharge Day",
        insight_rest_day_text: "Your quietest day was {date} with just {steps} steps. A well-deserved rest!",
        insight_sleep_consistency_title: "Sleep Routine",
        insight_sleep_consistency_text: "You slept over 7 hours on {days} nights!",
        insight_weekend_warrior_title: "Weekend Warrior",
        insight_weekend_warrior_text: "You crushed the weekend on {date} with {steps} steps.",
        insight_lowest_hr_title: "Zen Master",
        insight_lowest_hr_text: "Your lowest resting heart rate was {hr} bpm on {date}.",
        insight_bounce_back_title: "The Comeback",
        insight_bounce_back_text: "After resting on {restDate}, you bounced back with {steps} steps on {date}.",
        insight_max_distance_title: "Distance Demon",
        insight_max_distance_text: "Your longest trek was on {date}, covering {distance} km.",
        insight_min_sleep_title: "Night Owl",
        insight_min_sleep_text: "You powered through on just {sleep} of sleep on {date}.",
        insight_goal_crusher_title: "Goal Crusher",
        insight_goal_crusher_text: "You crushed the 10k steps goal on {days} different days!",
        kpi_card_title: "Fitness Insights",
        kpi_card_avg_steps: "Avg. Steps (Last 7 Days)",
        insight_weight_journey_title: "Weight Journey",
        insight_weight_journey_lost_text: "You've lost {diff} kg during this period!",
        insight_weight_journey_gained_text: "You've gained {diff} kg during this period.",
        insight_lowest_body_fat_title: "Lean Machine",
        insight_lowest_body_fat_text: "Your lowest body fat was {body_fat}% on {date}.",
        insight_peak_muscle_mass_title: "Muscle Peak",
        insight_peak_muscle_mass_text: "You hit a peak muscle mass of {muscle} kg on {date}!"
    },

    movies: {
        notification: {
            saved_personal_experience: "The personal experience has been saved.",
            personal_experience_deleted: "The personal experience has been deleted."
        },
        do_you_really_want_to_delete: "Do your really want to delete this experience?",
        header: "Movies",
        back: "Back",
        runtime: "Runtime",
        minutes: "Minutes",
        search_for_movies: "Search for movies...",
        have_you_watched_this_movie: "Have you watched this movie?",
        watched_where: "Watched were?",
        watched_where_cinema: "Cinema",
        watched_where_streamed: "Streamed (Netflix, Disney+, ...)",
        watched_where_tv: "TV (Free-TV Premiere, ...)",
        watched_where_both: "Watched in cinema and streamed or saw in TV",
        month: "Month",
        year: "Year",
        rating: "Rating",
        watched_when: "Watched when?",
        personal_experience: "Personal experience",
        library: "Library"
    },

    tvshows: {
        notification: {
            saved_personal_experience: "The personal experience has been saved.",
            personal_experience_deleted: "The personal experience has been deleted."
        },
        do_you_really_want_to_delete: "Do you really want to delete this experience?",
        header: "TV Shows",
        search_for_tvshows: "Search for TV shows...",
        library: "Library",
        seasons: "Seasons",
        back: "Back",
        have_you_watched_this_show: "Have you watched this show?",
        rating: "Rating",
        watched_when: "When did you start with the first episode?",
        month: "Month",
        year: "Year",
        personal_experience: "Personal experience"
    },
    drinks: {
        header: "Drinks",
        base_alcohol: "Base alcohol",
        ingredients: "Ingredients",
        type: "Type",
        rating: "Rating"
    },
    recipes: {
        header: "Recipes",
        process: "Process",
        ingredients: "Ingredients",
        duration: "Duration",
        type: "Type"
    },
    elements: {
        select_file: "Select file...",
        image: "Image",
        add: "Add",
        upload: "Upload",
        url: "URL",
        select: "Select",
        selected: "File selected"
    },
    fitness_workouts: {
        header: "Fitness Workouts",
        add_workout: "Start Workout",
        workout_name: "Workout Name",
        activities: "Activities",
        add_activity: "Add Activity",
        add_set: "Add Set",
        exercise_name: "Exercise Name",
        no_activities: "No activities added yet.",
        name: "Name",
        sets: "Sets",
        amount: "Amount / Reps",
        weight: "Weight",
        date: "Date",
        saving: "Saving...",
        saved: "Draft Saved",
        finish_workout: "Finish Workout",
        draft: "Draft",
        duration_min: "Duration (min)",
        distance: "Distance",
        calories: "Calories",
        locked_during_session: "Date is locked during active session",
        strength: "Strength",
        cardio: "Cardio",
        search_workouts: "Search Workouts",
        filter_all: "All",
        workouts_this_month: "Workouts this Month",
        duration_this_month: "Duration this Month",
        activities_this_month: "Activities this Month",
        vs_last_month: "vs last month",
        more_insights: "More Insights",
        distance_this_month: "Distance this Month",
        calories_this_month: "Calories this Month",
        weight_lifted_this_month: "Weight Lifted this Month",
        sets_this_month: "Sets this Month",
        timeframe_day: "Day",
        timeframe_week: "Week",
        timeframe_month: "Month",
        kpi_workouts: "Workouts",
        kpi_duration: "Duration",
        kpi_activities: "Activities",
        kpi_distance: "Distance",
        kpi_calories: "Calories",
        kpi_weight_lifted: "Weight Lifted",
        kpi_sets: "Sets",
        vs_yesterday: "vs yesterday",
        vs_last_week: "vs last week"
    },
    exercises: {
        bench_press: "Bench Press",
        incline_bench_press: "Incline Bench Press",
        dumbbell_press: "Dumbbell Press",
        squats: "Squats",
        deadlift: "Deadlift",
        leg_press: "Leg Press",
        leg_extension: "Leg Extension",
        leg_curl: "Leg Curl",
        calf_raises: "Calf Raises",
        overhead_press: "Overhead Press",
        lateral_raises: "Lateral Raises",
        pull_ups: "Pull-ups",
        lat_pulldown: "Lat Pulldown",
        barbell_row: "Barbell Row",
        seated_cable_row: "Seated Cable Row",
        push_ups: "Push-ups",
        bicep_curls: "Bicep Curls",
        hammer_curls: "Hammer Curls",
        tricep_extensions: "Tricep Extensions",
        tricep_dips: "Tricep Dips",
        lunges: "Lunges",
        bulgarian_split_squats: "Bulgarian Split Squats",
        hip_thrust: "Hip Thrust",
        crunches: "Crunches",
        leg_raises: "Leg Raises",
        shoulder_press_machine: "Shoulder Press Machine",
        rear_delt_fly: "Rear Delt Fly",
        butterfly_machine: "Butterfly Machine",
        chest_press_machine: "Chest Press Machine",
        cable_crossover: "Cable Crossover",
        smith_machine_squats: "Smith Machine Squats",
        smith_machine_bench_press: "Smith Machine Bench Press",
        ab_crunch_machine: "Ab Crunch Machine",
        kettlebell_swings: "Kettlebell Swings",
        farmers_walk: "Farmer's Walk",
        front_squats: "Front Squats",
        good_mornings: "Good Mornings",
        face_pulls: "Face Pulls",
        t_bar_rows: "T-Bar Rows",
        preacher_curls: "Preacher Curls",
        skull_crushers: "Skull Crushers",
        barbell_shrugs: "Barbell Shrugs",
        dumbbell_shrugs: "Dumbbell Shrugs",
        box_jumps: "Box Jumps",
        romanian_deadlift: "Romanian Deadlift",
        hack_squats: "Hack Squats",
        glute_kickbacks: "Glute Kickbacks",
        side_plank: "Side Plank",
        russian_twists: "Russian Twists",
        running: "Running",
        treadmill: "Treadmill",
        cycling: "Cycling",
        indoor_cycling: "Indoor Cycling",
        elliptical: "Elliptical",
        rowing: "Rowing",
        stairmaster: "Stairmaster",
        walking: "Walking",
        plank: "Plank",
        jump_rope: "Jump Rope",
        hip_abduction: "Hip Abduction",
        hip_adduction: "Hip Adduction",
        seated_calf_raises: "Seated Calf Raises"
    },
    source: "Source"
};

export default en;